import { useContext } from 'react';

import Auth0RoleDetailsContext from '@totem/components/services/remoteAccess/auth0role/details/Auth0RoleDetailsContext';
import { isNull } from '@totem/utilities/common';

const Auth0RolePageTitle = () => {
  const { role } = useContext(Auth0RoleDetailsContext);

  if (isNull(role)) return 'Role Details';

  return role.name;
};

export default Auth0RolePageTitle;
